exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-div[data-v-0e17af12]{width:160px;background:#66b1ff;color:#fff;padding:15px 10px;border-radius:8px;text-align:center;margin-left:18px;cursor:move;margin-bottom:10px}.esp[data-v-0e17af12]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}", ""]);

// exports
